import { getProductSelectedByDrugManufacturerId } from './getProductSelectedByDrugManufacturerId';

export const getSubtotalById = (id: string | number, products: any[], EX5937: boolean): number => {
    if (EX5937) {
        // este cambio es implementado ya que el amountSelected es el monto selecciónado para un producto,
        // pero esta función necesita retornar el total para esa droguería, amountSelected antes era valido,
        // porque no existia la posibilidad de tener +1 celda seleccionada por producto.
        const subtotalId = getProductSelectedByDrugManufacturerId(id, products, EX5937);
        const cellById = subtotalId?.map((item) => item?.products[id]?.total);
        const subtotal = cellById?.reduce((count, value) => (count += value), 0);
        return subtotal;
    } else {
        const subtotalId = getProductSelectedByDrugManufacturerId(id, products, EX5937)?.reduce(
            (count, item) => (count += item?.amountSelected),
            0,
        );

        return subtotalId;
    }
};